import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { Dashboard } from './pages/Dashboard';
import { UserManagement } from './pages/UserManagement';
import { BeneficiaryRegistry } from './pages/BeneficiaryRegistry';
import { OrganizationManagement } from './pages/OrganizationManagement';
import { GuideManagement } from './pages/GuideManagement';
import { ConservationManagement } from './pages/ConservationManagement';
import { HarvestManagement } from './pages/HarvestManagement';
import { TourManagement } from './pages/TourManagement';
import { VesselManagement } from './pages/VesselManagement';
import { ForestCompliance } from './pages/ForestCompliance';
import { SmartIdRfid } from './pages/SmartIdRfid';
import { Reports } from './pages/Reports';
import { UserFlow } from './pages/UserFlow';
import { MobileFieldOfficer } from './pages/MobileFieldOfficer';
import { RolePermission } from './pages/RolePermission';
import { LoginPage } from './pages/LoginPage';
import { BLCManagement } from './pages/BLCManagement';
import { SmartPermitIssuance } from './pages/SmartPermitIssuance';
import { SystemConfiguration } from './pages/SystemConfiguration';
import { MemberManagement } from './pages/MemberManagement';
function AppContent() {
  const location = useLocation();
  const isMobileView = location.pathname.startsWith('/mobile');
  if (isMobileView) {
    return <Routes data-id="element-0">
        <Route path="/mobile" element={<MobileFieldOfficer data-id="element-2" />} data-id="element-1" />
      </Routes>;
  }
  return <div className="flex min-h-screen bg-gray-50" data-id="element-3">
      <Sidebar data-id="element-4" />
      <main className="flex-1 ml-64 p-8" data-id="element-5">
        <Routes data-id="element-6">
          <Route path="/" element={<Dashboard data-id="element-8" />} data-id="element-7" />
          <Route path="/users" element={<UserManagement data-id="element-10" />} data-id="element-9" />
          <Route path="/roles" element={<RolePermission data-id="element-12" />} data-id="element-11" />
          <Route path="/beneficiaries" element={<BeneficiaryRegistry data-id="element-14" />} data-id="element-13" />
          <Route path="/organizations" element={<OrganizationManagement data-id="element-16" />} data-id="element-15" />
          <Route path="/guides" element={<GuideManagement data-id="element-18" />} data-id="element-17" />
          <Route path="/conservation" element={<ConservationManagement data-id="element-20" />} data-id="element-19" />
          <Route path="/harvest" element={<HarvestManagement data-id="element-22" />} data-id="element-21" />
          <Route path="/tour" element={<TourManagement data-id="element-24" />} data-id="element-23" />
          <Route path="/blc" element={<BLCManagement data-id="element-26" />} data-id="element-25" />
          <Route path="/members" element={<MemberManagement data-id="element-28" />} data-id="element-27" />
          <Route path="/smart-permit" element={<SmartPermitIssuance data-id="element-30" />} data-id="element-29" />
          <Route path="/vessels" element={<VesselManagement data-id="element-32" />} data-id="element-31" />
          <Route path="/compliance" element={<ForestCompliance data-id="element-34" />} data-id="element-33" />
          <Route path="/smart-id" element={<SmartIdRfid data-id="element-36" />} data-id="element-35" />
          <Route path="/reports" element={<Reports data-id="element-38" />} data-id="element-37" />
          <Route path="/config" element={<SystemConfiguration data-id="element-40" />} data-id="element-39" />
          <Route path="/user-flow" element={<UserFlow data-id="element-42" />} data-id="element-41" />
        </Routes>
      </main>
    </div>;
}
export function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  if (!isLoggedIn) {
    return <LoginPage onLogin={() => setIsLoggedIn(true)} data-id="element-43" />;
  }
  return <BrowserRouter data-id="element-44">
      <AppContent data-id="element-45" />
    </BrowserRouter>;
}